<template>
  <!-- namespace="el" 은 El Plus 기본값이며 전역 클래스 prefix 를 고정한다.
       SSR/hydration ID 충돌 방지는 plugins/element-plus.ts 에서
       ID_INJECTION_KEY prefix 를 고정값(1000)으로 제공해 처리한다. -->
  <el-config-provider namespace="el">
    <NuxtLayout>
      <!--
        keepalive: true → 탭 이동 시 컴포넌트를 언마운트하지 않고 캐시한다.

        ⚠️ max 옵션 제거 이유:
        KeepAlive 의 max LRU 캐시는 한도 초과 시 pruneCacheEntry() 로 캐시된
        컴포넌트를 unmount 하는데, 이 과정에서 cached.component 가 null 이면
        Vue 내부 unmountComponent 가 "Cannot destructure property 'bum' of null"
        에러를 던진다(KeepAlive + max 의 알려진 버그, async setup 페이지에서 빈발).
        탭은 stores/tab.ts MAX_TABS 로 이미 제한되고 페이지 컴포넌트 총수도 유한하므로
        max 없이도 캐시는 자연히 bounded — max 를 제거해 prune 경로 자체를 없앤다.
      -->
      <NuxtPage :keepalive="true" />
    </NuxtLayout>
    <!-- 세션 만료 시 화면 안에서 재로그인하는 모달(전역 1개) -->
    <SessionExpiredModal />
  </el-config-provider>
</template>